import {useCallback, useEffect, useState} from "react";

import {AuditLogRange, getAuditLogs} from "../api/auditLogs";

export const useAuditLogs = (userToken: string, range: AuditLogRange) => {
  const [loading, setLoading] = useState(false);
  const [auditLogs, setAuditLogs] = useState([]);

  const refetchAuditLogs = useCallback(async () => {
    if (!userToken) {
      return;
    }

    setLoading(true);
    try {
      const tempAuditLogs = await getAuditLogs(userToken, range);
      setAuditLogs(tempAuditLogs || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [userToken, range]);

  useEffect(() => {
    refetchAuditLogs();
  }, [refetchAuditLogs]);

  return {
    loading,
    auditLogs,
    refetchAuditLogs,
  };
};
